// extracted by mini-css-extract-plugin
module.exports = {"selectedItem":"followup_selectedItem__xgv84","mssUpdate":"followup_mssUpdate__3_dqW"};